import React, {useState, useEffect} from "react";
import { InputNumber, InputText, SelectDropdown, InputCheckBox } from "commons/input-controls";
import Keywords from 'items/keywords/keywords'
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';
import { StandartButton } from "commons/form-controls";
import List from "pages/settings-page/list/list";

import AdvancedItem from "../advanced/advanced-item/advanced-item";
import { ReactComponent as AngleUp } from 'assets/icons/angle-up.svg';
import { ReactComponent as AngleDown } from 'assets/icons/angle-down.svg';

import {ReactComponent as PlusIcon} from "assets/icons/plus.svg";
import {ReactComponent as CloseIcon} from "assets/icons/close.svg";

import s from '../topic-item.module.scss';
import ErrorBlock from "items/error-block/error-block";


const GeneralTopicSettings = (props) => {
    const getUserName = (userid, users, type = 'name') => {
        if(users && users.length){
            let user = users.findIndex(k => k.id === userid);
            return user !== -1 ? users[user][type] : null
        }
        else return null

    }

    const [users, setUsers] = useState(props.activeUsers ? props.activeUsers : []);
    const [topicId, setTopicId] = useState(props.topicItem && props.topicItem.id ? props.topicItem.id : null);
    const [topicTitle, setTopicTitle] = useState(props.topicName ? props.topicName : '');
    const [limit, setlimit] = useState(props.topicItem && props.topicItem.limit ? props.topicItem.limit : 5000);
    /*const [massMedia, setMassMedia] = useState(props.topicItem && props.topicItem.mediaLimit ? props.topicItem.mediaLimit : 2500);
    const [socialNetwork, setSocialNetwork] = useState(props.topicItem && props.topicItem.socialNetworkLimit ? props.topicItem.socialNetworkLimit : 2500);*/
    const [deleteOld, setDeleteOld] = useState(false);
    const [showDeleteOld, setShowDeleteOld] = useState(false)
    const [keywords, setKeywords] = useState(props.topicItem && props.topicItem.keywords ? props.topicItem.keywords : [])
    const [stopwords, setStopwords] = useState(props.topicItem && props.topicItem.stopwords ? props.topicItem.stopwords : [])
    const [socnetProfiles, setSocnetProfiles] = useState(props.topicItem && props.topicItem.socnetProfiles ? props.topicItem.socnetProfiles : []);
    const [resources, setResources] = useState(props.topicItem && props.topicItem.resources ? props.topicItem.resources : [])
    const [showOnly, setShowOnly] = useState(props.isEdit === 'show' ? true : false);
    const [parentTopicId, setParentTopicId] = useState(props.parentTopicId ? props.parentTopicId : null);
    const [migration, setMigration] = useState(true);
    const [profileMigration, setProfileMigration] = useState(true);
    const [selectedUser, setSelectedUser] = useState(props.selectedUser);
    //const [checkProfileItem, setCheckProfileItem] = useState(getProfileMessage(props.checkProfileItem, 'socnetProfiles'));
    //const [checkResourceItem, setCheckResourceItem] = useState(getProfileMessage(props.checkResourceItem, 'resources'));
    const [topicSettings, setTopicSettings] = useState(props.topicItem && props.topicItem.topicSettings ? props.topicItem.topicSettings : {});
    const [showItem, setShowItem] = useState({massMediaScale: true});
    const [socialInclude, setSocialInclude] = useState((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.socialInclude !== null && props.topicItem.topicSettings.socialInclude !== undefined) ? props.topicItem.topicSettings.socialInclude : true)
    const [socialAllowUndefinedLocation, setSocialAllowUndefinedLocation] = useState((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.socialAllowUndefinedLocation !== null && props.topicItem.topicSettings.socialAllowUndefinedLocation !== undefined) ? props.topicItem.topicSettings.socialAllowUndefinedLocation : true);
    const [massInclude, setMassInclude] = useState((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.massInclude !== null && props.topicItem.topicSettings.massInclude !== undefined) ? props.topicItem.topicSettings.massInclude : true)
    const [massDomainText, setMassDomainText] = useState(null);
    const [socialDomain, setSocialDomain] = useState((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.socialDomain) ? props.topicItem.topicSettings.socialDomain : []);
    const [massDomain, setMassDomain] = useState((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.massDomain) ? props.topicItem.topicSettings.massDomain : [])
    const [advertisement, setAdvertisement] = useState((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.advertisement !== null && props.topicItem.topicSettings.advertisement !== undefined) ? props.topicItem.topicSettings.advertisement : true);
    const [profanity, setProfanity] = useState((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.profanity !== null  && props.topicItem.topicSettings.profanity !== undefined) ? props.topicItem.topicSettings.profanity : true);
    const [isReviewInclude, setIsReviewInclude] = useState((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.reviewInclude !== null  && props.topicItem.topicSettings.reviewInclude !== undefined) ? props.topicItem.topicSettings.reviewInclude : true);
    const [isEdit, setIsEdit] = useState(props.isEdit);
    const [isSubtopic, setIsSubtopics] = useState(props.isSubtopic);
    const [rerender, setRerender] = useState(false);
    const [isChangedUsers, setIsChangedUsers] = useState(false);
    const [isShowExtendedSettings, setIsShowExtendedSettings] = useState(false);

    useEffect(() => {
        setTopicId(props.topicItem && props.topicItem.id ? props.topicItem.id : null);
        setTopicTitle(props.topicName ? props.topicName : '')
        setlimit(props.topicItem && props.topicItem.limit ? props.topicItem.limit : 5000);
        /*setMassMedia(props.topicItem && props.topicItem.mediaLimit ? props.topicItem.mediaLimit : 2500);
        setSocialNetwork(props.topicItem && props.topicItem.socialNetworkLimit ? props.topicItem.socialNetworkLimit : 2500);*/
        setTopicSettings(props.topicItem && props.topicItem.topicSettings ? props.topicItem.topicSettings : {});
        setDeleteOld(false);
        setKeywords(props.topicItem && props.topicItem.keywords ? props.topicItem.keywords : [])
        setStopwords(props.topicItem && props.topicItem.stopwords ? props.topicItem.stopwords : [])
        setSocnetProfiles(props.topicItem && props.topicItem.socnetProfiles ? props.topicItem.socnetProfiles : []);
        setResources(props.topicItem && props.topicItem.resources ? props.topicItem.resources : [])
        setParentTopicId(props.parentTopicId ? props.parentTopicId : null)
        setShowOnly(props.isEdit === 'show' ? true : false);
        setShowDeleteOld(false)
        //setCheckProfileItem(getProfileMessage(props.checkProfileItem, 'socnetProfiles'));
        //setCheckResourceItem(getProfileMessage(props.checkResourceItem, 'resources'));
        setUsers(props.activeUsers ? props.activeUsers : []);
        setSelectedUser(props.selectedUser);

        setIsEdit(props.isEdit);
        setSocialInclude((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.socialInclude !== null && props.topicItem.topicSettings.socialInclude !== undefined) ? props.topicItem.topicSettings.socialInclude : true)
        setMassInclude((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.massInclude !== null && props.topicItem.topicSettings.massInclude !== undefined) ? props.topicItem.topicSettings.massInclude : true);
        setMassDomain((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.massDomain) ? props.topicItem.topicSettings.massDomain : [])
        setSocialAllowUndefinedLocation((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.socialAllowUndefinedLocation !== null && props.topicItem.topicSettings.socialAllowUndefinedLocation !== undefined) ? props.topicItem.topicSettings.socialAllowUndefinedLocation : true);
        setAdvertisement((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.advertisement !== null  && props.topicItem.topicSettings.advertisement !== undefined) ? props.topicItem.topicSettings.advertisement : true);
        setProfanity((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.profanity !== null && props.topicItem.topicSettings.profanity !== undefined) ? props.topicItem.topicSettings.profanity : true);
        setIsReviewInclude((props.topicItem && props.topicItem.topicSettings && props.topicItem.topicSettings.reviewInclude !== null && props.topicItem.topicSettings.reviewInclude !== undefined) ? props.topicItem.topicSettings.reviewInclude : true);
        setIsSubtopics(props.isSubtopic);
        setRerender(!rerender);
    }, [props.topicItem, props.topicName, props.isEdit, props.parentTopicId, props.selectedUser, props.activeUsers])

    const createTopic = () => {
        const extendedSettings = getExtendedSettings();
        if(parentTopicId){

        }
        const newTopic = {
            //parentId: parentTopicId ? parentTopicId : null,
            name: topicTitle,
            limit: limit,
            relation: 'main',
            geoposition: 'kz'
        }

        if(parentTopicId) newTopic.parentId = parentTopicId
        let keys = keywords && keywords.length ? keywords.map(k => k.keyword) : [];
        let stop = stopwords && stopwords.length ? stopwords.map(k => k.keyword) : [];
        let res = resources ? resources.map(k => {return getDomains(k)}) : [];
        let prof = socnetProfiles ? socnetProfiles.map(k => {return getUrls(k)}) : [];

        props.createTopicSettings(newTopic, keys, stop, res, migration, prof, profileMigration, extendedSettings);
        
        setTopicTitle('');
        setlimit(5000);
        setDeleteOld(false);
        setKeywords([]);
        setStopwords([]);
        setSocnetProfiles([]);
        setResources([])
        setRerender(!rerender)
    }

    const getDomains = (k) => {
        return k.domain;
        let res = {domain: k.domain}
        if(k.id){
            res.id = k.id;
        }
        return res;
    }

    const getUrls = (k) => {
        return k.url;
        let res = {url: k.url}
        if(k.id){
            res.id = k.id;
        }

        return res;
    }

    const updateTopicsExtendedSettings = () => {
        const extendedSettings = getExtendedSettings();
        if(parentTopicId){

        }
        const updateTopic = {
            //parentId: parentTopicId ? parentTopicId : null,
            name: topicTitle,
            limit: limit,
            relation: 'main',
            geoposition: 'kz'
        }

        if(parentTopicId) updateTopic.parentId = parentTopicId
        let keys = keywords.map(k => k.keyword)
        let stop = stopwords.map(k => k.keyword)
        let res = resources ? resources.map(k => {return getDomains(k)}) : [];
        let prof = socnetProfiles ? socnetProfiles.map(k => {return getUrls(k)}) : [];
        props.updateExtendedTopicSettings(topicId, updateTopic, keys, stop, res, deleteOld, migration, prof, profileMigration, extendedSettings);
        
        setTopicTitle('');
        setlimit(5000);
        setDeleteOld(false);
        setKeywords([]);
        setStopwords([]);
        setSocnetProfiles([]);
        setResources([])
        setRerender(!rerender)
    }

    const getToDetachAccounts = () => {
        let detached = props.oldSelectedUser.filter(k => selectedUser.indexOf(k) === -1)
        return detached
    }

    const getAttached = () => {
        let attached = selectedUser.filter(k => props.oldSelectedUser.indexOf(k) === -1)

        return attached
    }
//props.editTopic(props.topicId, topicTitle, massMedia, socialNetwork, props.keywords, props.stopwords, props.profiles, props.deleteOld);

    const editTopic = (topicId) => {
        if(props.selectedRole === 'ROLE_ADMIN' && isChangedUsers){
            props.attachAccountsToTopics(selectedUser, topicId);
        }

        props.editTopic(topicId, topicTitle, limit, keywords, stopwords, socnetProfiles, resources, migration, profileMigration, deleteOld)
        setDeleteOld(false)
    }

    const addMassMedia = (value) => {
        setMassMedia(value)
        //props.addMassMedia(value);
    }

    const addLimit = (limit) => {
        setlimit(limit)
    }

    const addSocialNetwork = (value) => {
        setSocialNetwork(value)
        //props.addSocialNetwork(value)
    }

    const checkDeleteOld = () => {
        setDeleteOld(!deleteOld)
    }

    const setIsMigration = isMigration => {
        setMigration(isMigration)
    }

    const setProfileIsMigration = isMigration => {
        setProfileMigration(isMigration)
    }

    const getByType = (type) => {
        switch(type){
            case 'socnetProfiles':
                return 'url'
            case 'resources':
                return 'domain'
            default:
                return 'keyword'
        }
    }

    const getObjectByType = (type) => {
        switch(type){
            case 'keywords':
                return keywords
            case 'stopwords':
                return stopwords
            case 'socnetProfiles':
                return socnetProfiles
            case 'resources':
                return resources
        }
    }

    const setItemByType = (type, value) => {

        let keyWords = getObjectByType(type)
        let key = keyWords.findIndex(k => k[getByType(type)] === value);
        if(key === -1){
            keyWords.push({id: null, [getByType(type)]: value});
            switch(type){
                case 'keywords':
                    let ks = [...keyWords]

                    setKeywords(ks);
                    //setRerender(!rerender)
                    break;
                case 'stopwords':
                    let st = [...keyWords]
                    setStopwords(st);
                    break;
                case 'resources':
                    setResources(keyWords);
                    break;
                case 'socnetProfiles':
                    setSocnetProfiles(keyWords);
                    break;
            }
            setRerender(!rerender);
        }
    }

    const openKeywords = (type) => {
        const items = getObjectByType(type)
        props.modalShowToggle("Keywords", true, closeModal.bind(this, this), props.getValue(type.toUpperCase()), 
            <Keywords showOnly={showOnly} BigWindow={true} type={type} setItemByType={setItemByType} removeItemByType={removeItemByType} stopwords={items} keywords={items} getValue={props.getValue} reg={true} />);
    }

    const removeItemByType = (type, value) => {
        
        let keyWords = getObjectByType(type)
        
        let key = keyWords.findIndex(k => k[getByType(type)] === value);
        
        if(key !== -1){
            switch(type){
                case 'keywords':
                    let topicKeywords = props.topic && props.topic.keywords ? props.topic.keywords.split(',') : []
                    if(topicKeywords && topicKeywords.findIndex(f => f.trim() === value) !== -1){
                        setShowDeleteOld(true)
                    }
                    keyWords.splice(key, 1)
                    let ks = [...keyWords]
                    setKeywords(ks);
                    setRerender(!rerender)
                    break;
                case 'stopwords':
                    keyWords.splice(key, 1)
                    let ts = [...keyWords]
                    setStopwords(ts);
                    break;
                case 'socnetProfiles':
                    keyWords.splice(key, 1)
                    setSocnetProfiles(keyWords);
                    break;
                case 'resources':
                    keyWords.splice(key, 1)
                    setResources(keyWords);
                    break;
            }
            
            setRerender(!rerender);
        }
    }

    const closeModal = () => {
        props.modalShowToggle(false)
    }

    const showInstruction = () => {
        props.modalShowToggle("KeywordsInstruction", true,  closeModal, props.getValue('KEYWORDS')+" / "+props.getValue('STOPWORDS'), "Действие данной кнопки находтся в стадии разработки")
    }

    const setSelectedAccount = (usersIds) => {
        setIsChangedUsers(true);
        props.setSelectedUser(usersIds);
    }

    const addMassDomain = (e) => {
        let massDomains = massDomain;
        massDomains.push(massDomainText)
        setMassDomainText(null)
        setMassDomain(massDomains)
        setRerender(!rerender)
    }

    const removeMassDomain = (index) => {
        let massDomains = massDomain;
        massDomains.splice(index, 1)
        setMassDomain(massDomains)
        setRerender(!rerender)
    }

    const addMassDomainText = (e) => {
        setMassDomainText(e)
    }

    const toggleMassInclude = (e) => {
        setMassInclude(e)
    }

    const setInclude = (e) => {
        setSocialInclude(e)
        setRerender(!rerender)
    }

    const setAllowUndefinedLocation = (e) => {
        setSocialAllowUndefinedLocation(e)
        setRerender(!rerender)
    }

    const setIsAdvertisement = (e) => {
        setAdvertisement(e)
        setRerender(!rerender)
    }

    const setIsProfanaty = (e) => {
        setProfanity(e)
        setRerender(!rerender)
    }

    const setReviewInclude = (e) => {
        setIsReviewInclude(e);
        setRerender(!rerender);
    }

    const getObjectNameByTitle = (title) => {
        switch(title){
            case 'massCountryId':
            case 'socialLocationId':
                return 'countries'
            case 'languageList':
                return 'languages'
            default:
                return title
            
        }
    }

    const getExtendedSettings = () => {
        let item = {...topicSettings};
        let data = {} 
        Object.entries(item).forEach( ([k, v], i) => {
            data[k] = [];
            if((item[k] && (item[k].length === props[getObjectNameByTitle(k)])) || (!item[k] || !item[k].length)){
                delete data[k]
            }
            else{
                data[k] = item[k].map(f => f)
            }
        })
        data.massInclude = massInclude ? massInclude : false;
        data.socialInclude = socialInclude ? socialInclude : false;
        data.socialAllowUndefinedLocation = socialAllowUndefinedLocation ? socialAllowUndefinedLocation : false;

        if(massDomain && massDomain.length) data.massDomain = massDomain;
        data.aggression = true;
        data.profanity = profanity ? profanity : false;
        data.complaint = true
        data.advertisement = advertisement ? advertisement : false;
        data.reviewInclude = isReviewInclude ? isReviewInclude : false;
        return data;
    }

    const setSelecteItem = (title, item, id, list) => {
        let selectedAdvanced = {...topicSettings};
        let l = id ? id : list;
            if(!selectedAdvanced[title])
                selectedAdvanced[title] = [];
            let findedIndex = selectedAdvanced[title].indexOf(l.toString());
            if(findedIndex !== -1){
                selectedAdvanced[title].splice(findedIndex, 1);
            }
            else{
                selectedAdvanced[title].push(l.toString())
            }
        setTopicSettings(selectedAdvanced)
        setRerender(!rerender)
        //props.setSelectedAdvanced(title, {selectedList: id ? id : list, selectedName: item})
    }

    const setSelectedItemsAll = (title, isSelected, items, except) => {
        let selectedAdvancedAll = []
            if(isSelected){
                items.forEach((item) => {
                    if(except.findIndex(k => k.id === item.id) === -1)
                        selectedAdvancedAll.push(item.id ? item.id.toString() : item.list)// = item.list ? item.list : item.name
                });
            }
            /*else
                selectedAdvancedAll = {}*/
            let selectedAllAdvanced = topicSettings;
            
            if(items)
                selectedAllAdvanced[title] = selectedAdvancedAll
            else
                delete selectedAllAdvanced[title]
            setTopicSettings(selectedAllAdvanced)
            setRerender(!rerender)
    }

    const getSelectedItems = (title, items) => {
        return items && items[title] ? items[title] : []
    }

    const setShowItemBlock = (item, subitem) => {
        let itemsShow = showItem
        if(itemsShow[item])
            delete itemsShow[item]
        else{
            if(item === 'socialLocationId' || item === 'massCountryId'){
                getCountries()
            }
            itemsShow[item] = true
        }
        setShowItem(itemsShow)
        setRerender(!rerender);
    }

    const showBlockIcon = (e, item) => {
        return showItem[item] ? <AngleDown /> : <AngleUp />
    }

    const getDataByTitle = (title) => {
        switch(title){
            case 'massMediaScale':
                return props.massMediaScale;
            case 'massMediaType':
                return props.massMediaType;
            case 'massCountryId':
                return props.countries
            case 'massRegionId':
                return props.regions
            case 'sentimentList':
                return props.sentimentList
            case 'socialLocationId':
                return props.countries
            case 'socialDomain':
                return props.domains
            case 'publicationType':
                return props.publicationType
            case 'languageList':
                return props.languages
        }
    }

    const getCountries = () => {
        props.getCountries()
    }

    const setSelectedSocialItem = (item, e) => {
        props.setSelectedSocialItem(item, e)
    }

    const getTitle = (title) => {

        switch(title){
            case 'massInclude':
                return 'MASS_INCLUDE';
            case 'massMediaType':
                return 'SOURCE_TYPE';
            case 'massMediaScale':
                return 'MEDIA_SCALE'
            case 'massCountryId':
            case 'socialLocationId':
                return 'STATES'
            case 'massRegionId':
                return 'REGIONS'
            case 'publicationType':
                return 'POST_TYPE'
            case 'sentimentList':
                return 'SENTIMENT'
            case 'languageList':
                return 'LANGUAGE'
            case 'socialDomain':
                return 'RESOURCE'
            case 'isAdvertising':
                return 'isAdvertising'
            case 'commonLocationCountryId':
                return 'common_location_country_id'
            default:
                return title
        }
    }

    const showExtendedSettings = () => {
        setIsShowExtendedSettings(!isShowExtendedSettings)
    }

    const getBlock = (title) => {
        return  <div className={s.AdvancedItemBlock}>
                    <div className={s.TitleBlock}>
                        <span>{props.getValue(getTitle(title))}</span>
                        <div className={s.toggleButton} onClick={setShowItemBlock.bind(this, title)}>{ showBlockIcon(this, title) }</div>
                    </div>
                    <AdvancedItem 
                                selectedChanged={props.selectedChanged} 
                                items={getDataByTitle(title)} 
                                callback={setSelecteItem} 
                                selected={getSelectedItems(title, topicSettings)} 
                                title={title} setSelectedItemsAll={setSelectedItemsAll} 
                                getValue={props.getValue} showBlock={showItem[title]} 
                                countries={props.countries}
                                setSelectedSocialItem={setSelectedSocialItem}
                                regions={props.regions}
                                socialInclude={socialInclude}
                                setInclude={setInclude}
                                languages={props.languages}
                                setReviewInclude={setReviewInclude}
                                isEdit={isEdit}
                                //sng={props.sng}
                    />
                </div>
    }

    const socialDomainsListBlock = massDomain.map( (k, i) => 
                                                                <tr className={s.SocialDomains} key={i}>
                                                                    <td>{i+1}</td>
                                                                    <td>{k}</td>
                                                                    <td><button background="background" icon={CloseIcon} fill="white" onClick={removeMassDomain.bind(this, i)}><CloseIcon /></button></td>
                                                                </tr>)

    return (
        <div className={s.General}>
                        {props.isSubtopic && props.topic.TopicName ? <div className="formRow">
                            <div className="labelText">{props.getValue('TOPIC_NAME')}</div>
                            {/*props.isEdit !== 'create' && <InputText callback={setTopicTitleText} value={topicTitle} placeholder={props.getValue('ENTER_TOPIC_NAME')} readOnly={props.isEdit === 'show' && true}/>*/}
                            {<InputText disabled={true} value={props.topic.TopicName } placeholder={''} readOnly={true}/>}
                        </div> : null}
            { props.selectedRole === 'ROLE_ADMIN' && users && !props.isSubtopic 
            //&& props.topicItem.status === "ACTIVE"
            
                ?   <div className="formRow">
                        <div className="labelText">{props.getValue('ACCOUNTS')}</div>
                        <List list={users} setSelected={setSelectedAccount} selected={selectedUser} showOnly={showOnly}/>
                    </div>
                : null
            }
            {!props.isSubtopic ? <div className="formRow">
                <div className="labelText">
                    {props.getValue('SELECTION_LIMIT')}
                </div>
                {<InputNumber readOnly={showOnly} callback={addLimit} value={limit} min={0}/>}
            </div> : null}
            <div className="formRow">
                <div className="labelText">
                    {props.getValue('KEY_WORDS_2')} {props.isEdit !== 'show' && <span>•<span className={s.blueText+" "+s.showInstruction} onClick={showInstruction}> {props.getValue('KEY_WORDS_CREATION')}</span></span>}
                </div>
                {<Keywords showOnly={showOnly} type={'keywords'} setItemByType={setItemByType} removeItemByType={removeItemByType} keywords={keywords} getValue={props.getValue} reg={true} openKeywords={openKeywords.bind(this, 'keywords')}/>}
            </div>
            { showDeleteOld && <div className="formRow">
                <div className="labelText">
                    {props.getValue('CLEAR_DATA_CONTENTS_DELETED_KEYWORDS')}
                    <InputCheckBox isChecked={deleteOld} name="signin" title={props.getValue('CLEAR_DATA_CONTENTS_DELETED_KEYWORDS')} callback={checkDeleteOld}/>
                </div>

            </div>}
            <div className="formRow">
                <div className="labelText">
                    {props.getValue('STOP_WORDS')} {props.isEdit !== 'show' && <span>•<span className={s.blueText+" "+s.showInstruction} onClick={showInstruction}>{props.getValue('KEY_WORDS_CREATION')}</span></span>}
                </div>
                <Keywords showOnly={showOnly} type={'stopwords'} setItemByType={setItemByType} removeItemByType={removeItemByType} stopwords={stopwords} getValue={props.getValue} reg={true} openKeywords={openKeywords.bind(this, 'stopwords')}/>
            </div>
            <div className="formRow" style={{position: 'relative'}}>
                {props.errorInTopicItem && props.errorInTopicItem.errorType && props.errorInTopicItem.errorType === 'SOCNET_PROFILES' ? <ErrorBlock errorMessage={props.errorInTopicItem} styles={{top: '-15px', left: '-27px'}} getValue={props.getValue}/> : null}
                <div className="labelText">
                    {props.getValue('LINKS_TO_PROFILES')} {props.isEdit === 'edit'}
                </div>
                <Keywords title={'example.com/value'} showOnly={showOnly} type={'socnetProfiles'} setItemByType={setItemByType} removeItemByType={removeItemByType} getValue={props.getValue} profiles={socnetProfiles} reg={true}/>
            </div>
            {props.isEdit !== 'show' ? <div className="formRow">
                <div className="labelText">
                    {props.getValue('ARCHIVE_COLLECTION_BY_PRFILES')} {props.isEdit === 'edit'}
                </div>
                <InputCheckBox isChecked={profileMigration} name="profileMigration" title={props.getValue('CLEAR_DATA_CONTENTS_DELETED_KEYWORDS')} callback={setProfileIsMigration}/>
            </div> : null}
            <div className="formRow" style={{position: 'relative'}}>
                {props.errorInTopicItem && props.errorInTopicItem.errorType && props.errorInTopicItem.errorType === 'RESOURCES' ? <ErrorBlock errorMessage={props.errorInTopicItem} styles={{top: '-15px', left: '-27px'}} getValue={props.getValue}/> : null}
                <div className="labelText">
                    {props.getValue('LINKS_TO_SOURCES')} {props.isEdit === 'edit'}
                </div>
                <Keywords showOnly={showOnly} type={'resources'} setItemByType={setItemByType} removeItemByType={removeItemByType} getValue={props.getValue} resources={resources} domains={props.domains} reg={true}/>
            </div>
            {props.isEdit !== 'show' ? <div className="formRow">
                <div className="labelText">
                    {props.getValue('ARCHIVE_COLLECTION_BY_RESOURCES')} {props.isEdit === 'edit'}
                </div>
                <InputCheckBox isChecked={migration} name="migration" title={props.getValue('CLEAR_DATA_CONTENTS_DELETED_KEYWORDS')} callback={setIsMigration}/>
            </div> : null}
        <div className={s.extendedSettings}>
            <div onClick={showExtendedSettings}>
                <span>{props.getValue('EXTENDED_SETTINGS')}</span>
                { isShowExtendedSettings ? <AngleUp /> : <AngleDown /> }
                </div>
            </div>
        { isShowExtendedSettings ? <div className={s.Advanced}>
            <div className={s.AdvancedType}>
                <div className={s.AdvancedItemBlock}>
                    <div className={s.formRow}>
                        <InputCheckBox isDisabled={props.isEdit === 'show' ? true : false} isChecked={massInclude} name={ 'massInclude' } callback={toggleMassInclude} title={props.getValue('MASS_INCLUDE')} />
                        <span>{ props.getValue('MASS_INCLUDE') }</span>
                    </div>
                </div>
                {getBlock('massMediaType')}
                {getBlock('massMediaScale')}
                {(topicSettings && topicSettings.massMediaScale && topicSettings.massMediaScale.indexOf('REGIONAL') !== -1) ? props.regions.length && getBlock('massRegionId') : null}
                {(topicSettings && topicSettings.massMediaScale && topicSettings.massMediaScale.indexOf('INTERNATIONAL') !== -1) ? props.countries.length && getBlock('massCountryId') : null}
                {props.isEdit !== 'show' ? <div className={s.AdvancedItemBlock}>
                    <div className={s.formRow}>
                        
                        <InputText value={massDomainText} callback={addMassDomainText} name="filterText" type="text" placeholder={props.getValue('RESOURCE')}  />
                        <StandartButton disabled={!massDomainText || massDomainText === ''} title={props.getValue('ADD')} icon={PlusIcon} fill="white" callback={addMassDomain}/>
                    </div>
                    <div className={s.SocialDomains}>
                        {massDomain.length ? <table><tbody>{socialDomainsListBlock}</tbody></table> : null }
                    </div>
                </div> : null}
            </div>
            <div className={s.AdvancedType}>
                
                <div className={s.AdvancedItemBlock}>
                    <div className={s.formRow}>
                        <InputCheckBox isDisabled={props.isEdit === 'show' ? true : false} isChecked={socialInclude} name={props.getValue('SOCIAL_INCLUDE') } callback={setInclude} title={props.getValue("SOCIAL_INCLUDE")} />
                        <span>{ props.getValue('SOCIAL_INCLUDE') }</span>
                    </div>
                </div>
                {getBlock('socialDomain')}
                <div className={s.AdvancedItemBlock}>
                    <div className={s.formRow}>
                        <InputCheckBox isDisabled={props.isEdit === 'show' ? true : false} isChecked={socialAllowUndefinedLocation} name={props.getValue('SOCIAL_ALLOW_UNDEFINED_LOCATION') } callback={setAllowUndefinedLocation} title={props.getValue('SOCIAL_ALLOW_UNDEFINED_LOCATION')} />
                        <span>{ props.getValue('SOCIAL_ALLOW_UNDEFINED_LOCATION') }</span>
                    </div>
                </div>
                {getBlock('socialLocationId')}
            </div>
            <div className={s.AdvancedType}>
                <div className={s.AdvancedItemBlock}>
                <div className={s.formRow}>
                        <InputCheckBox isDisabled={props.isEdit === 'show' ? true : false} isChecked={isReviewInclude} name={props.getValue('reviewInclude') } callback={setIsReviewInclude} title={props.getValue('reviewInclude')} />
                        <span>{ props.getValue('reviewInclude') }</span>
                    </div>
                </div>
            </div>
            <div className={s.AdvancedType}>
                {getBlock('sentimentList')}
                {getBlock('publicationType')}
                {getBlock('languageList')}
            </div>
            <div className={s.AdvancedType}>
                <div className={s.AdvancedItemBlock}>
                    <div className={s.formRow}>
                        <InputCheckBox isDisabled={props.isEdit === 'show' ? true : false} isChecked={advertisement} name={props.getValue('ISADVERTISING') } callback={setIsAdvertisement} title={props.getValue('ISADVERTISING')} />
                        <span>{ props.getValue('ISADVERTISING') }</span>
                    </div>
                    <div className={s.formRow}>
                        <InputCheckBox isDisabled={props.isEdit === 'show' ? true : false} isChecked={profanity} name={props.getValue('ISSWEARING') } callback={setIsProfanaty} title={props.getValue('ISSWEARING')} />
                        <span>{ props.getValue('ISSWEARING') }</span>
                    </div>
                </div>
            </div>
            
        </div> : null}
        {props.isEdit !== 'show' ? <div className="formRow messageButton">
                {props.errorInTopicItem && !props.errorInTopicItem.errorType ? <ErrorBlock errorMessage={props.errorInTopicItem} styles={{bottom: '8px', left: '-12px'}} getValue={props.getValue}/> : null}
                <StandartButton disabled={!topicTitle || topicTitle === ''} callback={props.isEdit === 'edit' ? updateTopicsExtendedSettings.bind(this, topicId) : createTopic} title={props.getValue('SAVE')} icon={SaveIcon} fill={'white'}/>
            </div> : null}
        </div>
    )
}

export default GeneralTopicSettings